import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-non-programming',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './non-programming.component.html',
  styleUrls: ['./non-programming.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NonProgrammingComponent {}
